<template>
    <div class="md-goto-top">
        <GotoTop class="btn-top" icon="icon-arrow-down" :style="{ bottom: marginBottom }" />
    </div>
</template>
<script>
import { colorBlock } from '@/modules/defaultSpacing';
import GotoTop from './index.vue';
export default {
    data: function() {
        return {
            show: false,
            ...colorBlock,
            "noObserve": true,
            "sys_editable": false,
            "sys_deletable": 8,
            "sys_draggable": false,
            "topSpacing": null,
            "btmSpacing": 60,
            "mobileTopSpacing": null,
            "mobileBtmSpacing": 20
        };
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        }
    },
    components: {
        GotoTop
    }
};
</script>
<style lang="scss">
@import '~@/theme/media.scss';
@import '~@/theme/mixin.scss';

.md-goto-top {
    .btn-top {
        @include color-theme('background-color');
        @include media-800 {
            right: 18px;
        }
        .icon-arrow-down {
            transform: translate(-50%, -50%) rotate(180deg);
            color: #fff;
        }
    }
}
</style>
